import { ActionsContainer, NavBarContainer } from './styles';
import { Inset, StackChildren, Text } from '@doordash/design-language';
import { NavigationTypes, TitleSizes, TitleSizesTextStyles } from './constants';
import { IconButton } from '@doordash/component-button';
import ListCell from '@doordash/component-list-cell';
import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash.omit';

var NavBar = function NavBar(_ref) {
  var actions = _ref.actions,
      isRaised = _ref.isRaised,
      isSeparatorVisibleProp = _ref.isSeparatorVisible,
      maxNumberOfVisibleActions = _ref.maxNumberOfVisibleActions,
      navigationType = _ref.navigationType,
      noContentPadding = _ref.noContentPadding,
      onNavigationClick = _ref.onNavigationClick,
      onOverflowClick = _ref.onOverflowClick,
      parentTitle = _ref.parentTitle,
      subtext = _ref.subtext,
      strings = _ref.strings,
      textAlign = _ref.textAlign,
      title = _ref.title,
      titleSize = _ref.titleSize;
  var displaySubtext = parentTitle || subtext;
  var isSubtextFirst = !!(parentTitle && parentTitle.length);
  var displayTitleBelow = titleSize !== TitleSizes.Small;
  var isSquished = displayTitleBelow ? false : !!(parentTitle && parentTitle.length) || !!(subtext && subtext.length);
  /* eslint-disable no-nested-ternary */

  var isSeparatorVisible = typeof isSeparatorVisibleProp === 'boolean' ? isSeparatorVisibleProp : displayTitleBelow ? false : !isRaised;
  /* eslint-enable no-nested-ternary */

  return React.createElement(NavBarContainer, {
    isRaised: isRaised
  }, React.createElement(ListCell, {
    iconStart: navigationType === NavigationTypes.None ? undefined : {
      type: navigationType.icon,
      onClick: onNavigationClick,
      accessibilityLabel: strings && strings.navigationButtonLabel || navigationType.accessibilityLabel
    },
    textAlign: textAlign,
    title: !displayTitleBelow && title,
    subtext: !displayTitleBelow && displaySubtext,
    isSubtextFirst: isSubtextFirst,
    isSquished: isSquished,
    separatorType: ListCell.SeparatorTypes.FullBorder,
    isSeparatorVisible: isSeparatorVisible,
    renderAfterContent: actions && actions.length ? function () {
      return React.createElement(ActionsContainer, {
        style: {
          margin: isSquished ? '0 -8px 0 0' : -8,
          alignSelf: 'center',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center'
        }
      }, actions.slice(0, maxNumberOfVisibleActions).map(function (action) {
        return React.createElement("div", {
          key: action.accessibilityLabel,
          style: {
            flexShrink: 0
          }
        }, React.createElement(IconButton, action));
      }), actions.length > maxNumberOfVisibleActions && onOverflowClick && React.createElement("div", {
        key: "overflow",
        style: {
          flexShrink: 0
        }
      }, React.createElement(IconButton, {
        onClick: function onClick(event) {
          return onOverflowClick(actions.slice(maxNumberOfVisibleActions), event);
        },
        accessibilityLabel: "Other Actions",
        iconType: IconButton.IconTypes.MoreHorizontal
      })));
    } : undefined
  }), displayTitleBelow && React.createElement(Inset, {
    isSquished: true,
    size: noContentPadding ? 0 : undefined,
    style: {
      marginTop: -Inset.Sizes.Small
    }
  }, React.createElement(StackChildren, {
    size: StackChildren.Sizes.XxSmall
  }, isSubtextFirst && React.createElement(Text, {
    textAlign: textAlign,
    styles: TitleSizesTextStyles[titleSize].subtext
  }, displaySubtext), React.createElement(Text, {
    textAlign: textAlign,
    tag: "h2",
    styles: TitleSizesTextStyles[titleSize].title
  }, title), !isSubtextFirst && React.createElement(Text, {
    textAlign: textAlign,
    styles: TitleSizesTextStyles[titleSize].subtext
  }, displaySubtext))));
};

NavBar.propTypes = {
  isRaised: PropTypes.bool,
  isSeparatorVisible: PropTypes.bool,
  navigationType: PropTypes.oneOf(Object.values(NavigationTypes)),
  noContentPadding: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleSize: PropTypes.oneOf(Object.values(TitleSizes)),
  parentTitle: PropTypes.string,
  subtext: PropTypes.string,
  onNavigationClick: PropTypes.func,
  onOverflowClick: PropTypes.func,
  maxNumberOfVisibleActions: PropTypes.number,
  strings: PropTypes.shape({
    navigationButtonLabel: PropTypes.string
  }),
  textAlign: PropTypes.oneOf([Text.TextAlignments.Left, Text.TextAlignments.Center]),
  actions: PropTypes.arrayOf(PropTypes.shape(IconButton.propTypes))
};
NavBar.defaultProps = {
  isRaised: false,
  onNavigationClick: function onNavigationClick() {},
  navigationType: NavigationTypes.Back,
  strings: {},
  maxNumberOfVisibleActions: 2,
  textAlign: Text.TextAlignments.Left,
  titleSize: TitleSizes.Small
};
NavBar.TextAlignments = omit(Text.TextAlignments, ['Right', 'Justify']);
NavBar.TitleSizes = TitleSizes;
NavBar.NavigationTypes = NavigationTypes;
export default NavBar;